export function isMessageStreamingSelector(state) {
  if (state.inputField.timeoutStream) {
    return false;
  }

  return !!state.chatBody.streamMessages.length;
}
